import { Session } from "@chromia/ft4";

import { iPeriod, iVault, iWeb3Provider, pool, iClientInfo, iPriceGainInfo, iBalances, transactionStatus } from "../../common/interfaces/interfaces";
import { TypedGtxClient, iChrParams } from "../../common/interfaces/chromiaInterfaces";
import { Token } from "../../entities/Token";

export enum appActionTypes{
    SET_CLIENT_ADDR = 'APP/SET_CLIENT_ADDR',
    SET_VAULT = 'APP/SET_VAULT',
    SET_WEB3_PROVIDER = 'APP/SET_WEB3_PROVIDER',
    SET_PERIODS = 'APP/SET_PERIODS',
    SET_TOKEN = 'APP/SET_TOKEN',
    SET_VAULTS = 'APP/SET_VAULTS',
    SET_CLOSED_PERIOD = 'APP/SET_CLOSED_PERIOD',
    SET_POOL = 'APP/SET_POOL',
    SET_PARAMS = 'APP/SET_PARAMS',
    SET_ST_VAULT = 'APP/SET_ST_VAULT',
    SET_LT_VAULT = 'APP/SET_LT_VAULT',
    SET_CLIENT_INFO = 'APP/SET_CLIENT_INFO',
    SET_PRICE_GAIN_INFO = 'APP/SET_PRICE_GAIN_INFO',
    SET_ACCESS_TOKEN = 'APP/SET_ACCESS_TOKEN',
    SET_SESSION = 'APP/SET_SESSION',
    SET_CHR_CLIENT_ADDR = 'APP/SET_CHR_CLIENT_ADDR',
    SET_GTX_CLIENT = 'APP/SET_GTX_CLIENT',
    ADD_TOKEN = 'APP/ADD_TOKEN',
    SET_BALANCES = 'APP/SET_BALANCES',
    SET_TRANSACTION_STATUS = 'APP/SET_TRANSACTION_STATUS',
    SET_IS_INITING = 'APP/SET_IS_INITING',
    SET_FT_TOKEN = 'APP/SET_FT_TOKEN',
    CLEAR_APP_STATE = 'APP/CLEAR_APP_STATE',
}

export type app_actions_type = 
    set_client_addr |
    set_vault |
    set_web3_provider |
    set_periods |
    set_token |
    set_vaults |
    set_closed_period |
    set_pool |
    set_params |
    set_lt_vault |
    set_st_vault |
    set_price_gain_info |
    set_client_info |
    set_access_token |
    iSetSession |
    iSetGtxClient |
    iAddToken |
    iSetChrClientAddr |
    iSetBalances | 
    iSetTransactionStatus | 
    iSetIsIniting |
    iSetFToken |
    clear_app_state 
;

interface iSetFToken {
    type: appActionTypes.SET_FT_TOKEN,
    payload: string
}

interface iSetIsIniting {
    type: appActionTypes.SET_IS_INITING,
    payload: boolean
}

interface iSetTransactionStatus {
    type: appActionTypes.SET_TRANSACTION_STATUS,
    payload: transactionStatus
}


interface iSetChrClientAddr {
	type: appActionTypes.SET_CHR_CLIENT_ADDR,
	payload: string
}

interface set_access_token {
    type: appActionTypes.SET_ACCESS_TOKEN,
    payload: string
}

interface set_price_gain_info {
    type: appActionTypes.SET_PRICE_GAIN_INFO,
    payload: iPriceGainInfo
}

interface set_client_info {
    type: appActionTypes.SET_CLIENT_INFO,
    payload: iClientInfo | null
}

interface set_st_vault {
    type: appActionTypes.SET_ST_VAULT,
    payload: iVault
}

interface set_lt_vault {
    type: appActionTypes.SET_LT_VAULT,
    payload: iVault
}

interface set_params {
    type: appActionTypes.SET_PARAMS,
    payload: iChrParams
}

interface set_vault {
    type: appActionTypes.SET_VAULT,
    payload: pool | null
}

interface set_client_addr {
    type: appActionTypes.SET_CLIENT_ADDR,
    payload: string
}

interface set_web3_provider {
    type: appActionTypes.SET_WEB3_PROVIDER,
    payload: iWeb3Provider
}

interface clear_app_state {
    type: appActionTypes.CLEAR_APP_STATE
}

interface set_periods {
    type: appActionTypes.SET_PERIODS,
    payload: iPeriod[]
}

interface set_token {
    type: appActionTypes.SET_TOKEN,
    payload: string
}

interface set_vaults {
    type: appActionTypes.SET_VAULTS,
    payload: iVault[]
}

interface set_closed_period {
    type: appActionTypes.SET_CLOSED_PERIOD,
    payload: boolean
}

interface set_pool {
    type: appActionTypes.SET_POOL,
    payload: pool | null
}

interface iSetSession {
	type: appActionTypes.SET_SESSION,
	payload: Session
}

interface iSetGtxClient {
	type: appActionTypes.SET_GTX_CLIENT,
	payload: TypedGtxClient
}

interface iAddToken {
	type: appActionTypes.ADD_TOKEN,
	payload: Token
}

interface iSetBalances {
    type: appActionTypes.SET_BALANCES,
    payload: iBalances
}
